<template>
  <div>
    <!--<p>info@kingsleague.ca</p>
    <p>514-608-2297</p>-->
    <XNav :content="[{name:'Contact Us'}]" />

    <div class="box">
      <h2>{{$t('contactUs.contactUs')}}</h2>
      <div class="contact-info">
        <p>{{$t('contactUs.email')}} : <a href="mailto:info@kingsleague.ca">info@kingsleague.ca</a></p>
        <p>{{$t('contactUs.phone')}} : 1 877 TKL-7-TKL (<a href="tel:18778557855">1-877-855-7855</a>)</p>
      </div>
    </div>

    <div class="box">
      <h2>COMPLEXE SPORTIF DE SAINT-LAURENT</h2>
      <div class="leagues">
        <img src="@/assets/contact/COMPLEXE SPORTIF DE SAINT-LAURENT.jpg" alt="Complexe Sportif de Saint-Laurent indoor soccer facility" loading="lazy" />
        <div class="league-info">
          <p>{{$t("contactUs.fieldType")}}: Indoor Turf</p>
          <p>
            <a href="https://goo.gl/maps/mB5F1FvXyAiPBuQt6" target="_blank">2385 Boulevard Thimens,
            <br />Saint-Laurent, QC H4R 1T4
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <h2>PARC BERTHIAUME-DU TREMBLAY</h2>
      <div class="leagues inverted">
        <img src="@/assets/contact/BERTHIAUME-DU TREMBLAY.jpg" alt="Parc Berthiaume-Du Tremblay outdoor soccer field in Laval" loading="lazy" />
        <div class="league-info">
          <p>{{$t("contactUs.fieldType")}}: Outdoor Turf</p>
          <p>
            <a href="https://goo.gl/maps/CwSfLeQ4f2RdDN4R7" target="_blank">
            4250 Boulevard Lévesque O,
            <br />Laval, QC H7W 2P8
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <h2>COLLÈGE LETENDRE</h2>
      <div class="leagues">
        <img src="@/assets/contact/COLLEGE LETENDRE.jpg" alt="College Letendre outdoor soccer field in Laval" loading="lazy" />
        <div class="league-info">
          <p>{{$t("contactUs.fieldType")}}: Outdoor Turf</p>
          <p>
            <a href="https://goo.gl/maps/1oyBu5CZiGu4c8MEA" target="_blank">
            1000 Boulevard de l'Avenir,
            <br />Laval, QC H7N 6J6
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <h2>CENTRE MULTISPORTS DE ROSEMÈRE</h2>
      <div class="leagues">
        <img src="@/assets/contact/MULTISPORT ROSEMERE.jpg" alt="Centre Multisports de Rosemère indoor soccer facility" loading="lazy" />
        <div class="league-info">
          <p>{{$t("contactUs.fieldType")}}: Indoor Turf</p>
          <p>
            <a href="https://maps.google.com/?q=354+Mnt+Lesage+Rosemere+QC+J7A+4S5" target="_blank">354 Mnt Lesage,
            <br />Rosemère, QC J7A 4S5
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <h2>COLLÈGE BOIS-DE-BOULOGNE</h2>
      <div class="leagues inverted">
        <img src="@/assets/contact/COLLEGE BOIS DE BOULOGNE.webp" alt="College Bois-de-Boulogne outdoor soccer field in Montreal" loading="lazy" />
        <div class="league-info">
          <p>{{$t("contactUs.fieldType")}}: Outdoor Turf</p>
          <p>
            <a href="https://goo.gl/maps/gswzzvvba9Y5wvEn9" target="_blank">
            10555 Ave de Bois-de-Boulogne,
            <br />Montreal, Quebec H4N 1L4
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XNav from "@/components/XNav.vue";
export default {
  components: {
    XNav
  },
  metaInfo() {
    return {
      title: this.$t("seo_metadata.contact.title"),
      meta: [
        { vmid: "description", name: "description", content: this.$t("seo_metadata.contact.description") },
        { vmid: "keywords", name: "keywords", content: this.$t("seo_metadata.keywords") },
        { vmid: "og:title", property: "og:title", content: this.$t("seo_metadata.contact.title") },
        { vmid: "og:description", property: "og:description", content: this.$t("seo_metadata.contact.description") },
        { vmid: "og:url", property: "og:url", content: "https://kingsleague.ca/contact-us" },
        { vmid: "og:type", property: "og:type", content: "website"},
        { vmid: "twitter:title", name: "twitter:title", content: this.$t("seo_metadata.contact.title") },
        { vmid: "twitter:description", name: "twitter:description", content: this.$t("seo_metadata.contact.description") }
      ],
      link: [{ rel: "canonical", href: "https://kingsleague.ca/contact-us" }],
      script: [{
        type: "application/ld+json",
        json: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "SportsActivityLocation",
              "name": "Complexe Sportif de Saint-Laurent",
              "description": "Indoor turf soccer facility used by The Kings League in Montreal",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "2385 Boulevard Thimens",
                "addressLocality": "Saint-Laurent",
                "addressRegion": "QC",
                "postalCode": "H4R 1T4",
                "addressCountry": "CA"
              },
              "geo": { "@type": "GeoCoordinates", "latitude": 45.5017, "longitude": -73.6673 },
              "sport": "Soccer",
              "url": "https://kingsleague.ca/contact-us",
              "parentOrganization": { "@type": "SportsOrganization", "name": "The Kings League", "url": "https://kingsleague.ca" }
            },
            {
              "@type": "SportsActivityLocation",
              "name": "Centre Multisports de Rosemère",
              "description": "Indoor turf soccer facility used by The Kings League in Rosemère",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "354 Mnt Lesage",
                "addressLocality": "Rosemère",
                "addressRegion": "QC",
                "postalCode": "J7A 4S5",
                "addressCountry": "CA"
              },
              "sport": "Soccer",
              "url": "https://kingsleague.ca/contact-us",
              "parentOrganization": { "@type": "SportsOrganization", "name": "The Kings League", "url": "https://kingsleague.ca" }
            },
            {
              "@type": "SportsActivityLocation",
              "name": "Parc Berthiaume-Du Tremblay",
              "description": "Outdoor turf soccer field used by The Kings League in Laval",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "4250 Boulevard Levesque O",
                "addressLocality": "Laval",
                "addressRegion": "QC",
                "postalCode": "H7W 2P8",
                "addressCountry": "CA"
              },
              "sport": "Soccer",
              "url": "https://kingsleague.ca/contact-us",
              "parentOrganization": { "@type": "SportsOrganization", "name": "The Kings League", "url": "https://kingsleague.ca" }
            },
            {
              "@type": "SportsActivityLocation",
              "name": "College Letendre",
              "description": "Outdoor turf soccer field used by The Kings League in Laval",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "1000 Boulevard de l'Avenir",
                "addressLocality": "Laval",
                "addressRegion": "QC",
                "postalCode": "H7N 6J6",
                "addressCountry": "CA"
              },
              "sport": "Soccer",
              "url": "https://kingsleague.ca/contact-us",
              "parentOrganization": { "@type": "SportsOrganization", "name": "The Kings League", "url": "https://kingsleague.ca" }
            },
            {
              "@type": "SportsActivityLocation",
              "name": "College Bois-de-Boulogne",
              "description": "Outdoor turf soccer field used by The Kings League in Montreal",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "10555 Ave de Bois-de-Boulogne",
                "addressLocality": "Montreal",
                "addressRegion": "QC",
                "postalCode": "H4N 1L4",
                "addressCountry": "CA"
              },
              "sport": "Soccer",
              "url": "https://kingsleague.ca/contact-us",
              "parentOrganization": { "@type": "SportsOrganization", "name": "The Kings League", "url": "https://kingsleague.ca" }
            }
          ]
        }
      }, {
        type: "application/ld+json",
        json: {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://kingsleague.ca/" },
            { "@type": "ListItem", "position": 2, "name": "Contact Us", "item": "https://kingsleague.ca/contact-us" }
          ]
        }
      }]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/theme.scss";
.leagues {
  display: flex;
  flex-direction: column;

  & > img {
    width: 100%;
    height: auto;
  }
}
.league-info {
  @extend %secondary-pattern;
  color: white;
  font-size: 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h3 {
    font-size: 25px;
    text-transform: uppercase;
  }
  h3,
  p {
    margin: 15px;
    font-size: 20px;
  }
  a{
    color:white;
  }
}
.contact-info{
  background:$secondary;
  color:white;
  padding: 15px;
  p{
    margin: 7.5px 0px;
    a{
      color: white;
    }
  }
}
@media only screen and (min-width: $mobile-breakpoint) {
  .leagues {
    flex-direction: row;
    & > img {
      width: 50%;
    }
    &.inverted {
      flex-direction: row-reverse;
      text-align: right;
    }
    & > * {
      flex-basis: 50%;
    }
  }
}
</style>